import clsx from 'clsx';
import React from 'react';
import './style.scss';

const CustomCarouselControls = ({
  selectedItem,
  leftArrow,
  rightArrow,
  totalItems,
  classname = '', //gallery-component-slider-controls
  withProgress = false,
  nextDisabled,
  prevDisabled,
  swiperRef,
}) => {
  return (
    <div className={clsx(classname, 'custom-component-slider-controls')}>
      <div
        role="button"
        onClick={() => swiperRef?.current?.swiper?.slidePrev()}
        className={clsx('custom-component-slider-control', prevDisabled && 'disabled-control')}
      >
        <img src={leftArrow} alt="arrow" />
      </div>
      <div
        role="button"
        onClick={() => swiperRef?.current?.swiper?.slideNext()}
        className={clsx(
          'custom-component-slider-control right-control',
          nextDisabled && 'disabled-control'
        )}
      >
        <img src={rightArrow} alt="arrow" />
      </div>
      {withProgress && (
        <div className="custom-component-slider-progress">
          <span className="current">{selectedItem + 1}</span>
          <span className="total"> / </span>
          <span className="total">{totalItems}</span>
        </div>
      )}
    </div>
  );
};

export default CustomCarouselControls;
